module.exports = __webpack_public_path__ + "img/bg-round.3da13b7.png";